import { appApi } from '../app_api';

export const tablesApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getTables: builder.query({
      query: (eventId) => `/events/${eventId}/tables`,
      transformResponse: (response) => Array.isArray(response.data) ? response.data : [],
      providesTags: (result, error, eventId) => [{ type: 'EventTables', id: eventId }],
    }),
    addTables: builder.mutation({
      query: ({ eventId, nrOfTables }) => ({
        url: `/events/${eventId}/tables`,
        method: 'POST',
        body: { nrOfTables },
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'EventTables', id: eventId }],
    }),
    deleteTable: builder.mutation({
      query: ({ eventId, tableId }) => ({
        url: `/events/${eventId}/tables/${tableId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'EventTables', id: eventId }],
    }),
    editTable: builder.mutation({
      query: ({ eventId, tableId, newName }) => ({
        url: `/events/${eventId}/tables/${tableId}`,
        method: 'PUT',
        body: { name: newName },
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'EventTables', id: eventId }],
    }),
  }),
});

export const {
  useGetTablesQuery,
  useAddTablesMutation,
  useDeleteTableMutation,
  useEditTableMutation,
} = tablesApi;
